import Vue from 'vue'
import Router from 'vue-router'
import About from '@/components/About'
import Contact from '@/components/Contact'
import Home from '@/components/Home'
import PageNotFound from '@/components/PageNotFound'
import Projects from '@/components/Projects/Projects'
import ProjectStatus from '@/components/Projects/Status'
import ProjectType from '@/components/Projects/Type'
import Services from '@/components/Services/Services'
import Team from '@/components/Team/Team'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/projects/statuses/:alias',
      name: 'project-status',
      component: ProjectStatus
    },
    {
      path: '/projects/types/:alias',
      name: 'project-type',
      component: ProjectType
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/team',
      name: 'team',
      component: Team
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js